import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PhoneIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M19.22 15.25L16.7 14.96C16.09 14.89 15.49 15.1 15.06 15.53L13.21 17.38C11.791 16.66 10.504 15.721 9.39204 14.608C8.27904 13.496 7.34004 12.209 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.63004 3.77001 7.78004 3.01001 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.29504 9.34901 5.13404 13.188 7.97304 16.027C10.812 18.866 14.651 20.705 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C20.99 16.22 20.23 15.37 19.22 15.25Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PhoneIcon.propTypes = {
  sx: PropTypes.object,
};

export default PhoneIcon;
